import { TextInput } from '@tcl-boron-prefabs/text-input';
import React from 'react';
import { Controller } from 'react-hook-form';
import { get } from 'lodash';

const ControlledTextInput = ({
  control,
  name,
  label,
  placeholder,
  autoComplete,
  tabIndex,
  disabled,
  type,
  required,
  className,
  errors,
  pattern,
  validate,
}) => {
  return (
    <Controller
      control={control}
      name={name}
      rules={{ required: required ? 'This field is required' : false, validate, pattern }}
      render={({ field }) => (
        <TextInput
          onChange={field.onChange}
          value={field.value}
          label={label + (required ? ' *' : '')}
          type={type || 'text'}
          placeholder={placeholder ?? 'Enter'}
          disabled={disabled}
          required={required}
          className={className}
          status={get(errors, name) ? 'error' : 'default'}
          subContent={get(errors, name) ? <div>{get(errors, name)?.message}</div> : null}
          autoComplete={autoComplete}
          tabIndex={tabIndex}
        />
      )}
    />
  );
};

export default ControlledTextInput;
